import CatalogObjectSerializer from '@square/dashboard-items-data/serializers/connect/catalog-object';
export default class Discount extends CatalogObjectSerializer {}